'use client';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import classNames from 'classnames';
import { FC } from 'react';
import styles from './style.module.css';
import { useRouter, useSearchParams } from 'next/navigation';

interface PaginationProps {
  totalPages: number;
}

const Pagination: FC<PaginationProps> = ({ totalPages }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1', 10);

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;

    const queryParams = new URLSearchParams(searchParams);
    queryParams.set('page', page.toString());

    router.push(`?${queryParams.toString()}`);
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={classNames(styles.buttonNumber, {
            [styles.active]: i === currentPage,
          })}
          onClick={() => handlePageChange(i)}>
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.paginationContainer}>
        <button
          className={styles.buttonPrevious}
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          aria-label="Previous Page">
          <ArrowBackIcon />
        </button>
        {renderPageNumbers()}
        <button
          className={styles.buttonNext}
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          aria-label="Next Page">
          <ArrowForwardIcon />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
